import axios from "axios";
import GetServerAddress from "../../../../functions/GetServerAddress";

export async function Request_Get_ECs_Fuzzy_Search(
  dbName,
  collctiontext,
  searchName,
  AllAgencyIDsForChosenIPMember,
  limit,
  setdata,
  logoutStudent
) {
  try {
    const response = await axios.post(
      GetServerAddress() + "api/staff/Get_ECs_Fuzzy_Search",
      {
        dbName: dbName,
        collctiontext: collctiontext,
        limit: limit,
        searchName: searchName,
        AllAgencyIDsForChosenIPMember: AllAgencyIDsForChosenIPMember,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
          username: localStorage.getItem("Username"),
          activitylog: "No",
        },
      }
    );
    // Check for specific server response indicating an invalid auth token
    if (response.data.status === 403 || response.data.status === 401) {
      logoutStudent();
      return; // Stop further execution in case of invalid auth token
    }
    console.log("Response Data: ", response);
    setdata(response.data.data); // Update your state with the fetched data
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}
